var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgEwinFootballMatches(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "40px",
    height: "40px",
    viewBox: "0 0 40 40",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Icon/40x40px/eWin-index/Fb/Matches") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Asset",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "inplay-betting",
    transform: "translate(0.000000, 5.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M40.0000667,28.0938507 C40.0000667,29.5263047 31.0460517,30.6877013 20.0000333,30.6877013 C8.95468159,30.6877013 0,29.5263047 0,28.0938507 C0,26.6613966 8.95468159,25.5 20.0000333,25.5 C31.0460517,25.5 40.0000667,26.6613966 40.0000667,28.0938507",
    id: "Fill-7",
    fill: "#D8D8D8"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#569171",
    fillRule: "nonzero",
    x: 1,
    y: 0,
    width: 38,
    height: 28,
    rx: 2.53789997
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#00C06C",
    fillRule: "nonzero",
    x: 4,
    y: 2,
    width: 32,
    height: 23,
    rx: 1.4172
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.0247293,13.5 C14.0247293,9.99121244 16.592888,7.49509438 20,7.49509438 C23.407112,7.49509438 26.0112753,10.0081913 26.0112753,13.5 C26.0112753,16.9918087 23.407112,19.5376187 20.0019682,19.5376187 C16.5968243,19.5376187 14.0247293,17.0087876 14.0247293,13.5 Z M20,8.5091464 C18.0236796,8.50895059 16.1676133,9.74458533 15.4111801,11.5704142 C14.6547469,13.3962431 15.0214106,15.683184 16.4188225,17.0807113 C17.8162344,18.4782385 20.0567119,18.9073379 21.9181574,18.1333441 C23.779603,17.3593504 25.0013798,15.4763204 25.0013798,13.5 C25.0013798,10.6830032 22.6970985,8.5123924 20,8.5091464 Z",
    id: "Shape",
    fill: "#FFFFFF",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#FFFFFF",
    fillRule: "nonzero",
    x: 19.5,
    y: 2,
    width: 1,
    height: 6
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#FFFFFF",
    fillRule: "nonzero",
    x: 19.5,
    y: 19,
    width: 1,
    height: 6
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33,18.5 C30.7942245,18.5 29,16.2568348 29,13.4999572 C29,10.7430795 30.7943843,8.5 33,8.5 L33,9.48373314 C31.6753205,9.48373314 30.0042445,10.7802194 30.0042445,13.5 C30.0042445,16.2197806 31.6753205,17.5103173 33,17.5103173 L33,18.5 Z",
    id: "Path",
    fill: "#FFFFFF",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36,21.5 L34.2412455,21.5 C33.0041213,21.4989669 32.0014345,20.5883497 32,19.4645523 L32,7.53544773 C32.0014344,6.41171387 33.004012,5.50112298 34.241066,5.5 L35.9998205,5.5 L35.9998205,6.49923552 L34.241066,6.49923552 C33.4778091,6.49923552 33,6.99774941 33,7.53544773 L33,19.4645523 C33,20.0820518 33.633837,20.4650282 34.2412455,20.4650282 L36,20.4650282 L36,21.5 Z",
    id: "Path",
    fill: "#FFFFFF",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11,18.5 C8.79422455,18.5 7,16.2568348 7,13.4999572 C7,10.7430795 8.79438431,8.5 11,8.5 L11,9.48373314 C9.67532053,9.48373314 8.00424447,10.7802194 8.00424447,13.5 C8.00424447,16.2197806 9.67532053,17.5103173 11,17.5103173 L11,18.5 Z",
    id: "Path",
    fill: "#FFFFFF",
    fillRule: "nonzero",
    transform: "translate(9.000000, 13.500000) scale(-1, 1) translate(-9.000000, -13.500000) "
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8,21.5 L6.24124549,21.5 C5.00412134,21.4989669 4.00143454,20.5883497 4,19.4645523 L4,7.53544773 C4.00143437,6.41171387 5.00401196,5.50112298 6.24106602,5.5 L7.99982054,5.5 L7.99982054,6.49923552 L6.24106602,6.49923552 C5.47780906,6.49923552 5,6.99774941 5,7.53544773 L5,19.4645523 C5,20.0820518 5.63383696,20.4650282 6.24124549,20.4650282 L8,20.4650282 L8,21.5 Z",
    id: "Path",
    fill: "#FFFFFF",
    fillRule: "nonzero",
    transform: "translate(6.000000, 13.500000) scale(-1, 1) translate(-6.000000, -13.500000) "
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.6584524,12.9677922 L19.0255065,11.0823173 C18.8139725,10.9725514 18.5533644,10.9725616 18.3418409,11.0823439 C18.1303174,11.1921263 18,11.3950042 18,11.6145633 L18,15.3854367 C18,15.6049958 18.1303174,15.8078737 18.3418409,15.9176561 C18.5533644,16.0274384 18.8139725,16.0274486 19.0255065,15.9176827 L22.6584524,14.0319782 C22.8698195,13.9221515 23,13.7193447 23,13.4998852 C23,13.2804257 22.8698195,13.0776189 22.6584524,12.9677922 L22.6584524,12.9677922 Z",
    id: "Path",
    fill: "#FFC600",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#FFC600",
    fillRule: "nonzero",
    x: 16,
    y: 26,
    width: 8,
    height: 1,
    rx: 0.5
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEwinFootballMatches);
export default __webpack_public_path__ + "static/media/ewin_football_matches.a9e4cf2f9e39b0154f80bafc7ff3357d.svg";
export { ForwardRef as ReactComponent };